var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "empty-box", class: { "borer-box": _vm.border } },
    [
      _c("img", {
        attrs: { src: _vm.emptyImgMap[_vm.type], alt: "", srcset: "" },
      }),
      _c("p", [_vm._v(_vm._s(_vm.tip))]),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }